'use client';

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from './toast';
import { useToast } from './useToast';

/** `underAppBar`: the dashboard's placement, below its app bar (see ToastViewport). */
export function Toaster({ underAppBar = false }: { underAppBar?: boolean } = {}) {
  const { toasts } = useToast();
  // One toast at a time (TOAST_LIMIT): the newest decides where the viewport sits.
  const placement = toasts[0]?.placement;

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, placement: _placement, ...props }) {
        return (
          <Toast key={id} position={underAppBar ? 'underAppBar' : 'default'} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && <ToastDescription>{description}</ToastDescription>}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport underAppBar={underAppBar} data-placement={placement} />
    </ToastProvider>
  );
}
